import * as screen from '../../../../common/screen/screenActions';
import selectors from '../../../../rootSelectors';
import { goToPassage, goToInterstitial } from '../../../../common/navigation/navigationActions';
import { RCT, FLUENCY, FLUENCY_COMPREHENSION } from '../../../../constants/measure';
import {
    updateSelectedComprehensionResponses, updateQuestionIndex, resetQuestionIndex,
    setIsReadyScriptPlayed, saveComprehensionResponse,
} from '../../../rctActions';
import { setPlaylistItemCompleted } from '../../../../common/playlist/playlistActions';
import { resetSelectedIndex, selectPossibleResponse } from '../../../../common/questions/questionsActions';
import { narrateStart, narrateReset } from '../../../../common/audio/audioActions';
import { playAvatarAudio, setAvatarInstructions } from '../../../../common/avatar/avatarActions';
import RCT_AUDIO_INSTRUCTIONS from '../../../rctConstants';

const COMPREHENSION_AUDIO = RCT_AUDIO_INSTRUCTIONS.COMPREHENSION;

export const playReadyScript = () => (dispatch, getStore) => {
    const state = getStore();
    if (!selectors.getIsReadyScriptPlayed(state)) {
        dispatch(screen.deactivateNextButton());
        dispatch(screen.blockScreen());
        dispatch(screen.greyOutScreen());
        dispatch(narrateStart());
        return dispatch(playAvatarAudio([COMPREHENSION_AUDIO.avatarReady]))
            .then(() => {
                dispatch(narrateReset());
                dispatch(setIsReadyScriptPlayed(true));
                dispatch(screen.unblockScreen());
                dispatch(screen.colorInScreen());
            });
    }

    return Promise.resolve();
};

export const restoreSelectedResponse = () => (dispatch, getStore) => {
    const state = getStore();
    const questionIndex = selectors.getQuestionIndex(state);
    const listOfSelectedResponses = selectors.getSelectedComprehensionResponses(state);
    const newSelectedIndex = listOfSelectedResponses[questionIndex];
    if (typeof newSelectedIndex !== 'undefined') {
        dispatch(selectPossibleResponse(newSelectedIndex));
        dispatch(screen.activateNextButton());
    } else {
        dispatch(resetSelectedIndex());
        dispatch(screen.deactivateNextButton());
    }
};

export const activateGoBackButton = () => (dispatch, getStore) => {
    const state = getStore();
    const questionIndex = selectors.getQuestionIndex(state);
    if (questionIndex !== 0) {
        dispatch(screen.enableGoBackButton());
    } else {
        dispatch(screen.disableGoBackButton());
    }
};

export const onNextButtonClick = (activePassageIndex) => (dispatch, getStore) => {
    const state = getStore();

    if (selectors.getIsScreenGreyedOut(state)) {
        dispatch(screen.colorInScreen());
        dispatch(setAvatarInstructions(COMPREHENSION_AUDIO.avatarQuestion));
        dispatch(screen.deactivateNextButton());
    } else {
        dispatch(screen.blockScreen());
        return dispatch(saveComprehensionResponse(activePassageIndex))
            .then((isComplete) => {
                const questionIndex = selectors.getQuestionIndex(state);
                const totalQuestions = selectors.getComprehensionQuestionCount(state, activePassageIndex);

                dispatch(screen.unblockScreen());
                if (questionIndex < (totalQuestions - 1)) {
                    const index = questionIndex + 1;
                    dispatch(updateQuestionIndex(index));
                    dispatch(restoreSelectedResponse());
                    dispatch(activateGoBackButton());
                } else if (!isComplete) {
                    return Promise.resolve()
                        .then(() => {
                            // Advancing to the next passage. Plus 2 because we need 1 for the
                            // autual passage advancing and another 1 for the difference between
                            // activePassageIndex in the state and the passage number in the URL
                            // (activePassageIndex starts at 0; passage number starts at 1).
                            dispatch(goToPassage(RCT, FLUENCY, activePassageIndex + 2));
                        });
                } else {
                    dispatch(setPlaylistItemCompleted(FLUENCY_COMPREHENSION));
                    dispatch(goToInterstitial());
                }

                return Promise.resolve();
            });
    }
    return Promise.resolve();
};

export const onBackButtonClick = () => (dispatch, getStore) => {
    const state = getStore();
    const questionIndex = selectors.getQuestionIndex(state);
    if (questionIndex > 1) {
        const index = questionIndex - 1;
        dispatch(updateQuestionIndex(index));
        dispatch(screen.activateNextButton());
    } else {
        dispatch(resetQuestionIndex());
        dispatch(screen.disableGoBackButton());
    }
};

export const saveSelectedResponse = (questionIndex, responseIndex) => (dispatch) => {
    dispatch(updateSelectedComprehensionResponses(questionIndex, responseIndex));
};
